import styled from 'styled-components';

const Style = styled.div`
    #loading {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 99;
        background-color: rgb(255 255 255 / 30%);
        img {
            width: 50px;
        }
    }
`;
export default Style;
